import { Formik, Form } from 'formik'
import { BookEnum } from '@interfaces/BookEnum'
import cn from 'classnames'

import { Button } from '@components/Buttons'
import { OrderedEnum } from '@interfaces/OrderedEnum'
import { CrossIcon } from '@components/icons/CrossIcon'
import { AdvanceIcon } from '@components/icons/AdvanceIcon'
import { RecommendTypeSearchEnum } from '@interfaces/RecommendTypeSearchEnum'
import { MultiSelectField } from '@components/forms/MultiSelectField'
import { SortField } from '@components/forms/SortField'
import { SelectButtonField } from '@components/forms/SelectButtonField'
import { AdvanceSearchFormProps } from './interface'
import { SearchField } from '../SearchField'

const bookType = [
  { value: BookEnum.NOVEL, label: 'นิยาย' },
  { value: BookEnum.MANGA, label: 'การ์ตูน' },
]

const orderedOptions = [
  {
    value: OrderedEnum.NEW_OLD,
    title: 'วันอัปเดต',
    label: 'ใหม่ - เก่า',
  },
  {
    value: OrderedEnum.OLD_NEW,
    title: 'วันอัปเดต',
    label: 'เก่า - ใหม่',
  },
  {
    value: OrderedEnum.POPULAR,
    title: 'ความนิยม',
    label: 'มาก - น้อย',
  },
  {
    value: OrderedEnum.POPULAR_LESS,
    title: 'ความนิยม',
    label: 'น้อย - มาก',
  },
]

const defaultTypeOptions = [
  // { value: RecommendTypeSearchEnum.WHOLE, text: 'ตอนเดียว' },
  // { value: RecommendTypeSearchEnum.CHAPTER, text: 'มีมากกว่า 1 ตอน' },
  { value: RecommendTypeSearchEnum.ENDED, text: 'จบแล้ว' },
  { value: RecommendTypeSearchEnum.NOT_END, text: 'ยังไม่จบ' },
]

export function AdvanceSearchForm({
  initialValues,
  advanceSearch,
  categories,
  isLoading,
  handleSubmit,
  handleReset,
  handleAdvanceSearchChange,
}: AdvanceSearchFormProps) {
  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ resetForm }) => (
          <Form>
            <div className='flex flex-col space-y-[20px] z-20 mb-[20px] tablet-mobile:mb-[10px]'>
              <div className='flex space-x-[20px] mobile:space-x-0 mobile:space-y-[20px] mobile:flex-col'>
                <div className='flex flex-row w-full'>
                  <SearchField
                    name='searchText'
                    placeholder='ค้นหาด้วยชื่อเรื่อง, นักเขียน, แท็ก, ตัวละคร หรืออื่นๆ'
                    inputClassName='font-light bg-gray-4 text-secondary-1 w-full rounded-[20px] '
                    className='flex-1 w-full'
                  />
                  <button
                    type='button'
                    onClick={() => handleReset(resetForm)}
                    className='desktop-tablet:hidden ml-[5px]'
                  >
                    <CrossIcon className='text-secondary dark:text-dark-10 cursor-pointer' />
                  </button>
                </div>
                <Button
                  type='button'
                  onClick={handleAdvanceSearchChange}
                  className={cn('border  h-[40px] w-max mobile:w-full', {
                    'text-white bg-secondary dark:bg-purple dark:border-purple':
                      !advanceSearch,
                    'text-secondary border-secondary dark:border-dark-10':
                      advanceSearch,
                  })}
                  icon={
                    <AdvanceIcon
                      className={cn({
                        'text-white dark:text-white-2': !advanceSearch,
                        'text-secondary dark:text-dark-10': advanceSearch,
                      })}
                    />
                  }
                >
                  <span className='text-[14px] w-max font-medium dark:text-white-2'>
                    การค้นหาขั้นสูง
                  </span>
                </Button>
              </div>
              {advanceSearch && (
                <div className='flex flex-col space-y-[20px]'>
                  <div className='grid grid-cols-2 mobile:grid-cols-1 gap-[20px] flex-1'>
                    <MultiSelectField
                      name='bookType'
                      label='ลักษณะงานเขียน'
                      placeholder='ลักษณะงานเขียน'
                      options={bookType}
                    />
                    <MultiSelectField
                      name='categoryIds'
                      label='หมวดหมู่'
                      placeholder='หมวดหมู่'
                      options={categories}
                    />
                  </div>
                  <div className='grid grid-cols-400-1-1 tablet:grid-cols-2 mobile:grid-cols-1 gap-[20px] flex-1'>
                    <SortField
                      name='orderBy'
                      isShowLabel
                      options={orderedOptions}
                    />
                    <SelectButtonField
                      name='secondaryType'
                      options={defaultTypeOptions}
                      label='ประเภท'
                      mode='line'
                      className='w-fit overflow-auto'
                    />
                    <div className='flex items-center justify-end ml-[25px] space-x-[5px] tablet:hidden mobile:ml-0 mobile:pb-[20px] mobile:border-b mobile:border-gray-3 dark:mobile:border-purple'>
                      <Button
                        type='button'
                        className='text-secondary dark:text-dark-10 underline'
                        onClick={() => handleReset(resetForm)}
                      >
                        <span className='text-[14px] font-medium'>ล้างค่า</span>
                      </Button>
                      <Button
                        type='submit'
                        className='bg-primary dark:bg-purple text-white dark:text-dark-10'
                        disabled={isLoading}
                      >
                        <span className='text-[14px]'>ค้นหา</span>
                      </Button>
                    </div>
                  </div>
                  <div className='flex items-center justify-end space-x-[5px] desktop:hidden mobile:hidden pb-[20px] border-b border-gray-3 '>
                    <Button
                      type='button'
                      className='text-secondary underline'
                      onClick={() => handleReset(resetForm)}
                    >
                      <span className='text-[14px] font-medium'>ล้างค่า</span>
                    </Button>
                    <Button
                      type='submit'
                      className='bg-primary text-white '
                      disabled={isLoading}
                    >
                      <span className='text-[14px]'>ค้นหา</span>
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}
